var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconCafeteria(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m10.04 16.33 3.33-3.3L5.1 4.8a4.67 4.67 0 0 0 0 6.63l4.94 4.9Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.27 12.6c-1.88 1.86-4.41 2.44-6.22 1.61l-1.75 1.72-1.66 1.64-8.13 8.04-1.66-1.65 11.52-11.42c-.84-1.79-.25-4.3 1.63-6.16 2.27-2.24 5.5-2.67 7.23-.95 1.73 1.71 1.28 4.92-.96 7.16Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m22.76 25.63-6.87-6.8 1.66-1.65 6.87 6.8-1.66 1.64Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4 1a3 3 0 0 0-3 3v22a3 3 0 0 0 3 3h22a3 3 0 0 0 3-3V4a3 3 0 0 0-3-3H4ZM0 4a4 4 0 0 1 4-4h22a4 4 0 0 1 4 4v22a4 4 0 0 1-4 4H4a4 4 0 0 1-4-4V4Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCafeteria);
export default ForwardRef;